import React, { useState } from "react";
import { isEmpty, get, values } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import { faExclamationCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import payrollFrequency from "../../../mocks/payrollFrequency.json";
import { useEffect } from "react";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  SliderPanel,
  FieldInputDollar,
  AddToolTip,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  calculateTotalNoOfInstallments,
  LOAN_STATUS,
  LOAN_STATUS_REPORT,
} from "../../../utils";
import {
  getAmortizationSchedule,
  getLoanRepaymentDetailReport,
  getDownloadLoanRepaymentDetailReport,
  getCompaniesDropDown,
  getPlansDropDown,
  getMasterPlanList,
  getMasterLoanTypes,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "../402ContributionLimit/columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";
import moment from "moment";
import { Link } from "react-router-dom";
import AmortizationSchedule from "../../Distribution/LoanSummaryContainer/AmortizationSchedule/AmortizationSchedule";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    return <td>$ {parseFloat(value).toFixed(2)}</td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}
const today = new Date();
const initialValues = {
  companyId: null,
  planName: "All",
  payDateTo: new Date(today.setDate(today.getDate())),
  payDateFrom: new Date(today.setDate(today.getDate() - 30)),
  paymentFrequency: null,
  loanStatus: 0,
  submittedDate: 0,
};

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Company",
    className: "column-companyName",
    columnName: "companyName",
    field: "companyName",
    width: 150,
    dataType: "alphaNumeric",
    field1: "companyName",
  },
  {
    value: 2,
    label: "Plan",
    className: "column-planId",
    columnName: "planId",
    field: "planName",
    width: 120,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 3,
    label: "Particpant",
    className: "column-employeeName",
    columnName: "employeeName",
    field: "employeeName",
    width: 160,
    dataType: "alphaNumeric",
    field1: "employeeName",
  },
  {
    value: 4,
    label: "Loan Type",
    className: "column-loanType",
    columnName: "loanType",
    field: "loanType",
    width: 120,
    dataType: "alphaNumeric",
    field1: "loanType",
  },

  {
    value: 5,
    label: "Payment Frequency",
    className: "column-paymentFrequency",
    columnName: "paymentFrequency",
    field: "paymentFrequency",
    width: 200,
    dataType: "alphaNumeric",
    field1: "paymentFrequency",
  },
  {
    value: 6,
    label: "Interest rate",
    className: "column-interestRate",
    dataType: "alphaNumeric",
    columnName: "interestRate",
    field: "interestRate",
    width: 160,
    field1: "interestRate",
  },
  {
    value: 7,
    label: "Loan Tenure",
    className: "column-loanTenure",
    columnName: "loanTenure",
    dataType: "alphaNumeric",
    field: "loanTenure",
    width: 140,
    field1: "loanTenure",
  },
  {
    value: 8,
    label: "Orginal loan amount",
    className: "column-originalLoanAmount",
    columnName: "originalLoanAmount",
    field: "originalLoanAmount",
    dataType: "amount",
    width: 200,
    field1: "originalLoanAmountFrom",
    field2: "originalLoanAmountTo",
  },
  {
    value: 9,
    label: "Outstanding Principle Amount",
    className: "column-outstandingPrincipleAmount",
    columnName: "outstandingPrincipleAmount",
    field: "outstandingPrincipleAmount",
    dataType: "amount",
    width: 250,
    field1: "outstandingPrincipleAmountFrom",
    field2: "outstandingPrincipleAmountTo",
  },

  {
    value: 10,
    label: "Loan Status",
    className: "column-loanStatus",
    columnName: "loanStatus",
    field: "loanStatus",
    dataType: "alphaNumeric",
    width: 200,
    field1: "loanStatus",
  },
  {
    value: 11,
    label: "Reamortization Schedule",
    className: "column-reamortizationSchedule",
    columnName: "reamortizationSchedule",
    field: "id",
    dataType: "schedule",
    width: 210,
    field1: "reamortizationSchedule",
  },
];

const LoanRepaymentDetail = (props) => {
  const [final, setFinal] = useState(columns);
  const [gridFilters, setGridFilters] = useState();
  console.log("gridFilters", gridFilters);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
  ]);

  const [totalRecord, setTotalRecord] = useState(0);
  const formName = manageReportsFormNames.LOAN_REPAYMENT_DETAIL_REPORT;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [loanType, setLoanType] = useState([]);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [sliderOpen4, setSliderOpen4] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [trigger, setTrigger] = useState(true);
  const allOption = { label: "All", value: null };
  const [isScroll, setIsScroll] = useState(false);
  const [sorting, setSorting] = useState();
  const [responseLoading, setResponseLoading] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);

  const [
    loanRepaymentDetailDataTable,
    setLoanRepaymentDetailDataTable,
  ] = useState([]);
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const onViewClick = (id) => {
    getAmortizationSchedule(id)
      .then((res) => {
        setResponseLoading(false);
        setAmortizationSchedule(res);
      })
      .catch((err) => {
        setResponseLoading(false);
      });
  };

  class KendoGridReAmortizationCell extends React.Component {
    render() {
      const value = this.props.dataItem[this.props.field];
      return (
        <td>
          <p
            onClick={() => {
              setSliderOpen4(true);
              onViewClick(value);
            }}
            style={{
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "16px",
              color: "#307BF6",
            }}
          >
            View
          </p>
        </td>
      );
    }
  }

  const apiCall = (data) => {
    setDataLoading(true);
    getLoanRepaymentDetailReport({
      companyId: data?.companyId ?? 0,
      planId: data?.planId ?? 0,
      loanType: data?.loanType ?? null,
      loanStatus: data?.loanStatus ?? 0,
      paymentFrequency: data?.paymentFrequency ?? null,
      nameOrSSN: data?.nameOrSSN ?? null,
      submittedDate: data?.submittedDate ?? 0,
      loanRequestDateFrom: data?.loanRequestDateFrom ?? null,
      loanRequestDateTo: data?.loanRequestDateTo ?? null,
      loanActivationDateFrom: data?.loanActivationDateFrom ?? null,
      loanActivationDateTo: data?.loanActivationDateTo ?? null,
      loanClosedDateFrom: data?.loanClosedDateFrom ?? null,
      loanClosedDateTo: data?.loanClosedDateTo ?? null,
      from: 1,
      count: 20,
      innerFilters: data?.innerFilters,
      selectedColumns: [],
    })
      .then((response) => {
        setDataLoading(false);
        setLoanRepaymentDetailDataTable(
          response.loanRepaymentDetailReportData.map((_) => {
            return (_ = { ..._, loanStatus: LOAN_STATUS_REPORT[_.loanStatus] });
          })
        );
        setTotalRecord(response.count);
        if (response?.loanRepaymentDetailReportData?.length < 20)
          setStopInfiniteScroll(true);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });

    //setToggle(!toggle);
  };

  useDeepEffect(() => {
    setStopInfiniteScroll(false);
    if (!isEmpty(companyList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);
  const getFilters = (values) => {
    return {
      companyId: values.companyId ? values.companyId : 0,
      sponsorOrganizationId: values.sponsorOrganizationId
        ? values.sponsorOrganizationId
        : 0,
      planId: values.companyId
        ? planList.length === 1
          ? planList[0].planId
          : !values.planId
          ? 0
          : values.planId
        : 0,
      loanType: values.companyId
        ? loanType.length === 1
          ? loanType[0].planId
          : !values[fields.loanTypeLabel]
          ? null
          : values[fields.loanTypeLabel]
        : null,

      from: 1,
      count: 20,
      innerFilters: {
        columnName: "",
        orderBy: "",
      },
      selectedColumns: selectedColumns,
      nameOrSSN: values.nameOrSSN,
      loanStatus: values.loanStatus ?? null,
      paymentFrequency: values.paymentFrequency ?? null,
      loanRequestDateFrom:
        values[fields.submittedDate] === 1 ? values[fields.fromDate] : null,
      loanRequestDateTo:
        values[fields.submittedDate] === 1 ? values[fields.toDate] : null,
      loanActivationDateFrom:
        values[fields.submittedDate] === 2 ? values[fields.fromDate] : null,
      loanActivationDateTo:
        values[fields.submittedDate] === 2 ? values[fields.toDate] : null,
      loanClosedDateFrom:
        values[fields.submittedDate] === 3 ? values[fields.fromDate] : null,
      loanClosedDateTo:
        values[fields.submittedDate] === 3 ? values[fields.toDate] : null,
      submittedDate: values[fields.submittedDate],
    };
  };
  const onSubmit = (values) => {
    setGridFilters(null);
    setStopInfiniteScroll(false);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = getFilters(values);
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setLoanRepaymentDetailDataTable([]);
      setCompanyList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    if (stopInfiniteScroll) return;
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          ...filteredValues,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getLoanRepaymentDetailReport(filters)
          .then((response) => {
            setDataLoading(false);
            if (response === []) {
              setIsScroll(false);
            }
            // if (!isScroll) {
            //   setTableContent(response);
            // } else {
            setLoanRepaymentDetailDataTable([
              ...loanRepaymentDetailDataTable,
              ...response.loanRepaymentDetailReportData.map((_) => {
                return (_ = {
                  ..._,
                  loanStatus: LOAN_STATUS_REPORT[_.loanStatus],
                });
              }),
            ]);
            if (response?.loanRepaymentDetailReportData?.length < 20)
              setStopInfiniteScroll(true);

            // setIsScroll(false);
            //}
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));

    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownloadLoanRepaymentDetailReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `LoanRepayementDetailReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div> -</div>}</td>;
  };

  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  return (
    <ManageReportLayout rptName="Loan Repayment Detail Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
              // payDateTo: new Date(today.setDate(today.getDate())),
              // payDateFrom: new Date(today.setDate(today.getDate() - 30))
            }}
            onSubmit={onSubmit}
            //enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              console.log("values", values);
              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    //fieldsToExculde: [fields.payDateFrom, fields.payDateTo],
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
                getMasterLoanTypes(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setLoanType(response);
                    if (response.length === 1) {
                      setFieldValue([fields.loanType], response[0]?.loanType);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              // const OnSponsorChange = (value) => {
              //   setValues({
              //     ...clearFieldValues({
              //       values: values,
              //       fieldsToClear: [fields.planId, fields.planName],
              //     }),
              //     [fields.sponsorOrganizationId]:
              //       value || value === 0 ? parseInt(sponsors[value].id) : null,
              //     [fields.sponsorOrganizationName]:
              //       value || value === 0 ? sponsors[value].name : "Select One",
              //   });

              //   getMasterPlanList(get(sponsors[value], "id", 0))
              //     .then((response) => {
              //       setPlanList(response);
              //       if (response.length === 1) {
              //         setFieldValue([fields.planName], response[0]?.planName);
              //       }
              //     })
              //     .catch((error) => {
              //       //Handle Error
              //     });
              // };

              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };
              const selectLoanTypeOptions =
                loanType.length > 0
                  ? loanType && !isEmpty(values[fields.loanType])
                    ? [
                        allOption,
                        ...loanType.map((loan, index) => ({
                          label: loan.description,
                          value: loan.id,
                        })),
                      ]
                    : loanType && [
                        ...loanType.map((loan, index) => ({
                          label: loan.description,
                          value: loan.id,
                        })),
                      ]
                  : [];
              console.log("selectLoanTypeOptions", selectLoanTypeOptions);
              const onLoanTypeChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.loanTypeLabel,
                    selectLoanTypeOptions.find((_) => _.value === value).label
                  );
                  setFieldValue(fields.loanType, value);
                } else {
                  setFieldValue(fields.loanType, null);
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10 header-button-form"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div
                    className="d-flex align-item-center justify-content-between"
                    style={{ width: "fit-content" }}
                  >
                    <div className="d-flex mr-2">
                      {/* <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      /> */}
                      <Field
                        size="xs"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        disabled={values[fields.sponsorOrganizationName]}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value)
                            ? "Required"
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3">
                        <Field
                          size="xs"
                          isRequired
                          label="Plan id"
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                        <div className="d-flex ml-3 mr-2">
                          <Field
                            size="xs"
                            isRequired
                            label="Loan Type"
                            name={fields.loanType}
                            value={
                              values[fields.loanType]
                                ? values[fields.loanType]
                                : values[fields.companyName] && "All"
                            }
                            placeholder="Select"
                            options={selectLoanTypeOptions}
                            direction="bottom"
                            popupContent={
                              <SearchableList
                                options={selectLoanTypeOptions}
                                onSelect={(value) => onLoanTypeChange(value)}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div className="d-flex ml-2 mr-3">
                          <Field
                            size="xs"
                            isRequired
                            label="Loan Status"
                            name={fields.loanStatus}
                            value={values[fields.loanStatus]}
                            options={[
                              allOption,
                              ...toOptionValuesFromMapper(LOAN_STATUS_REPORT),
                            ]}
                            placeholder="Select"
                            direction="bottom"
                            // validate={(value) =>
                            //   values[fields.sponsorOrganizationName] &&
                            //   ["", undefined, null, "Select One"].includes(value)
                            //     ? "Select a plan"
                            //     : null
                            // }
                            popupContent={
                              <SearchableList
                                options={[
                                  allOption,
                                  ...toOptionValuesFromMapper(
                                    LOAN_STATUS_REPORT
                                  ),
                                ]}
                                onSelect={(value) =>
                                  setFieldValue(fields.loanStatus, value)
                                }
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>

                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="xs"
                            placeholder="Search SSN, Name, ID"
                            label="Employee Search"
                            isRequired
                            name={fields.nameOrSSN}
                            type="text"
                            autoComplete="off"
                            value={values[fields.nameOrSSN]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          {values[fields.nameOrSSN] &&
                            values[fields.nameOrSSN].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  top: "5px",
                                  height: "100%",
                                  marginTop: "30px",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="xs"
                                  onClick={() => {
                                    setFieldValue(fields.nameOrSSN, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>

                        <div className="d-flex ml-3 mr-2">
                          <Field
                            size="xs"
                            isRequired
                            label="Frequency"
                            name={fields.paymentFrequency}
                            value={values[fields.paymentFrequency]}
                            placeholder="Select"
                            direction="bottom"
                            options={[
                              allOption,
                              ...payrollFrequency.data.filter(
                                (x) => ![6, 7].includes(x.value)
                              ),
                            ]}
                            // validate={(value) =>
                            //   values[fields.sponsorOrganizationName] &&
                            //   ["", undefined, null, "Select One"].includes(value)
                            //     ? "Select a plan"
                            //     : null
                            // }
                            popupContent={
                              <SearchableList
                                options={[
                                  allOption,
                                  ...payrollFrequency.data.filter(
                                    (x) => ![6, 7].includes(x.value)
                                  ),
                                ]}
                                onSelect={(value, label) => {
                                  if (value !== null)
                                    setFieldValue(
                                      fields.paymentFrequency,
                                      label
                                    );
                                  else
                                    setFieldValue(
                                      fields.paymentFrequency,
                                      null
                                    );
                                }}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                      </div>
                      <div className="d-flex br-0">
                        <Field
                          size="xs"
                          isRequired
                          label="Submitted"
                          name={fields.submittedDate}
                          value={values[fields.submittedDate]}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.LOAN_REPAYMENT_DETAIL_SUBMMITED_DATE
                          )}
                          placeholder="Select"
                          direction="bottom"
                          // validate={(value) =>
                          //   values[fields.sponsorOrganizationName] &&
                          //   ["", undefined, null, "Select One"].includes(value)
                          //     ? "Select a plan"
                          //     : null
                          // }
                          popupContent={
                            <SearchableList
                              options={toOptionValuesFromMapper(
                                OPTIONS_DATA_MAPPER.LOAN_REPAYMENT_DETAIL_SUBMMITED_DATE
                              )}
                              onSelect={(value) =>
                                setFieldValue(fields.submittedDate, value)
                              }
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-12 bl-0 br-0">
                        <Field
                          size="sm"
                          label="From date"
                          isRequired
                          name={fields.fromDate}
                          value={usDateFormat(values[fields.fromDate])}
                          direction="CalendarLeftStyle"
                          isDatePicker
                          onClear={() => setFieldValue(fields.fromDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.fromDate, value)
                              }
                              value={usDateFormat(values[fields.fromDate])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-12 bl-0">
                        <Field
                          size="sm"
                          label="To Date"
                          isRequired
                          name={fields.toDate}
                          value={usDateFormat(values[fields.toDate])}
                          direction="CalendarLeftStyle"
                          isDatePicker
                          onClear={() => setFieldValue(fields.toDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.toDate, value)
                              }
                              value={usDateFormat(values[fields.toDate])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.fromDate] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                "To Date" should be greater than "From Date"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                      {/* <div className="d-flex pad-top-10">
                        <div
                          style={{ width: "167.467px", marginTop: "20px " }}
                          className="ft-12 grey-text font-weight-500 d-flex"
                        >
                          <Button
                            style={{
                              marginBottom: "12px",
                              marginLeft: "20px",
                              marginRight: "15px",
                            }}
                            className="sort-button"
                            variant="secondary"
                            onClick={(e) => {
                              setValues({
                                ...clearFieldValues({
                                  values,
                                  fieldsToClear: [
                                    fields.planId,
                                    fields.planName,
                                    fields.companyId,
                                    fields.companyName,
                                    fields.loanType,
                                    fields.loanStatus,
                                    fields.paymentFrequency,
                                    fields.submittedDate,
                                    fields.fromDate,
                                    fields.toDate,
                                    fields.nameOrSSN,
                                  ],
                                }),
                              });
                              setFieldValue(fields.nameOrSSN, "");
                              setFieldValue(fields.planName, null);
                              setFieldValue(fields.planId, null);
                              setPlanList([]);
                              setErrors({});
                              setTotalRecord(0);
                              setLoanRepaymentDetailDataTable([]);
                              setCompanyList("");
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            className="sort-button"
                            style={{
                              lineHeight: "19px",
                              marginRight: "10%",
                              marginBottom: "12px",
                              //width: "177.467px"
                            }}
                            variant="secondary"
                            type="submit"
                          >
                            Search
                          </Button>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="d-flex" style={{ marginLeft: "81%" }}>
                    <div
                      style={{ width: "167.467px" }}
                      className="ft-12 grey-text font-weight-500 d-flex"
                    >
                      <Button
                        style={{
                          marginBottom: "12px",
                          marginLeft: "20px",
                          marginRight: "15px",
                        }}
                        className="sort-button"
                        variant="secondary"
                        onClick={(e) => {
                          setValues({
                            ...clearFieldValues({
                              values,
                              fieldsToClear: [
                                fields.planId,
                                fields.planName,
                                fields.companyId,
                                fields.companyName,
                                fields.loanType,
                                fields.loanStatus,
                                fields.paymentFrequency,
                                fields.submittedDate,
                                fields.fromDate,
                                fields.toDate,
                                fields.nameOrSSN,
                              ],
                            }),
                          });
                          setFieldValue(fields.nameOrSSN, "");
                          setFieldValue(fields.planName, null);
                          setFieldValue(fields.planId, null);
                          setPlanList([]);
                          setErrors({});
                          setTotalRecord(0);
                          setLoanRepaymentDetailDataTable([]);
                          setCompanyList("");
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        className="sort-button"
                        style={{
                          lineHeight: "19px",
                          marginRight: "10%",
                          marginBottom: "12px",
                          //width: "177.467px"
                        }}
                        variant="secondary"
                        type="submit"
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{ maxWidth: "100%", maxWidth: "1210px" }}
                    className="d-flex justify-content-between align-center divSpace header-button min-width-200 mr-0"
                  >
                    <div className="d-flex w-100">
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#828282",
                          paddingTop: "6px",
                        }}
                      >
                        <div className="d-flex flex-column">
                          {companyList
                            ? `Showing result for ${companyList} company`
                            : null}
                        </div>
                        <div className="ft-12 grey-text font-weight-500">
                          {totalRecord} Records found
                        </div>
                      </div>

                      {/* <div
                        onClick={() => {
                          setSliderOpen(true);
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#307BF6",
                          }}
                        >
                          View
                        </p>
                      </div> */}

                      <SliderPanel
                        isOpen={sliderOpen}
                        size="60"
                        showCancel={false}
                        backdropClicked={() => setSliderOpen(false)}
                      >
                        <div
                          className="disp-flex-row"
                          style={{
                            justifyContent: "space-between",
                            fontWeight: "500",
                            fontSize: "16px",
                            borderBottom: "1px solid #BDBDBD",
                          }}
                        >
                          <p>Amortization Schedule</p>
                          <FontAwesomeIcon
                            icon={faTimes}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSliderOpen(false)}
                          />
                        </div>

                        {sliderOpen && (
                          <Grid
                          // data={CalculateAmortizationSchedule({
                          //   frequency: values["repaymentFrequency"],
                          //   loanRequestAmout: get(
                          //     values,
                          //     [fields.requestedAmount],
                          //     null
                          //   ),
                          //   interest:
                          //     values["interestRate"] == 1
                          //       ? prime
                          //       : values["interestRate"] == 2
                          //       ? prime + values["interestRateValue"]
                          //       : values["interestRateValue"],
                          //   tenureYears: get(
                          //     values,
                          //     [fields.tenureYears],
                          //     null
                          //   ),
                          //   tenureMonths: get(
                          //     values,
                          //     [fields.tenureMonths],
                          //     null
                          //   ),
                          //   periodicPayment: get(
                          //     values,
                          //     [fields.periodicPayment],
                          //     null
                          //   ),
                          //   firstRepaymentDate: get(
                          //     values,
                          //     [fields.firstRepaymentDate],
                          //     null
                          //   ),
                          // })}
                          >
                            <GridColumn
                              field="installmentCount"
                              title="Installment #"
                              width="120"
                            />

                            <GridColumn
                              field="scheduledRepaymentDate"
                              title="Scheduled Repayment Date"
                              width="220"
                            />
                            <GridColumn
                              field="expectedRepaymentAmount"
                              title="Expected Repayment Amount"
                              width="250"
                            />
                            <GridColumn
                              field="actualRepaymentDate"
                              title="Actual Repayment Date"
                              width="200"
                            />
                            <GridColumn
                              field="actualRepaymentAmount"
                              title="Actual Repayment Amount"
                              width="220"
                            />
                            <GridColumn
                              field="principalPaid"
                              title="Principal paid"
                              width="130"
                            />
                            <GridColumn
                              field="interestPaid"
                              title="Interest paid"
                              width="120"
                            />
                            <GridColumn
                              field="outstandingPrincipal"
                              title="Outstanding Principal"
                              width="190"
                            />
                            <GridColumn
                              field="status"
                              title="Status"
                              width="90"
                            />
                          </Grid>
                        )}
                      </SliderPanel>

                      <SliderPanel
                        isOpen={sliderOpen4}
                        size="60"
                        onClose={() => setSliderOpen4(false)}
                        showCancel={true}
                        backdropClicked={() => setSliderOpen4(false)}
                      >
                        <AmortizationSchedule
                          amortizationSchedule={amortizationSchedule}
                          hideDownload={true}
                        />
                        <div
                          className="mt-3 ml-3"
                          style={{ display: "flex", flexDirection: "row" }}
                        >
                          <FontAwesomeIcon
                            style={{
                              fontWeight: "300",
                              fontSize: "17px",
                              color: "#333333",
                              marginRight: "5px",
                            }}
                            icon={faExclamationCircle}
                          />
                          <p style={{ fontWeight: "400", fontSize: "14px" }}>
                            The values shown are indicative and could vary based
                            on different factors such as First Repayment date,
                            NAV fluctuations.
                          </p>
                        </div>
                      </SliderPanel>
                      <div className="d-flex ml-auto">
                        <div
                          style={{
                            diplay: "flex",
                            flexDirection: "column",
                            marginLeft: "100px",
                          }}
                        >
                          <div>
                            <Button
                              variant="secondary"
                              className="column-header col-sty"
                              onClick={showManageColumns}
                            >
                              <span className="marg-right-6">
                                <i class="fal fa-columns"></i>
                              </span>
                              Column
                            </Button>
                          </div>
                          <div
                            className="manage-column-dropdown"
                            style={{ display: "none" }}
                          >
                            <div className="manage-columns ">
                              <p className="manage-columns-button">
                                {" "}
                                Manage columns
                              </p>
                              <p
                                className="apply-button"
                                onClick={() => {
                                  hideColumns();
                                  setTrigger(!trigger);
                                }}
                              >
                                Close
                              </p>
                            </div>
                            <div>
                              <MultiSelectDropdown
                                hideSelectedOptions="FALSE"
                                width="269px"
                                height="200px"
                                maxHeight="300px"
                                position="absolute"
                                background="white"
                                zIndex="2"
                                options={columns}
                                onSelect={(value) => {
                                  setSelectedColumns(value);
                                }}
                                name={"Columns"}
                                value={selectedColumns}
                                trigger={trigger}
                                // disabled={}
                                // isTypeAhead={isEdit}
                              />
                            </div>
                            <div
                              style={{
                                marginTop: "220px",
                                paddingLeft: "100px",
                              }}
                            >
                              <Button onClick={applyColumns}>Apply</Button>
                            </div>
                          </div>
                        </div>
                        <Button
                          className="export-button"
                          title="Export Excel"
                          variant="secondary"
                          style={{ border: "none" }}
                          // onClick={<ExcelExport />}
                          onClick={() =>
                            !isEmpty(loanRepaymentDetailDataTable) &&
                            exportReportFile()
                          }
                        >
                          <Image src={ExcelImage} width="20px" />
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={loanRepaymentDetailDataTable}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={loanRepaymentDetailDataTable}
                  total={loanRepaymentDetailDataTable?.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "date" && dateForm) ||
                        (column.dataType === "schedule" &&
                          KendoGridReAmortizationCell) ||
                        renderValue
                      }
                      // AmotizationSchedule={
                      //   column.columnName === "reamortizationSchedule" &&
                      //   KendoGridReAmortizationCell
                      // }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(loanRepaymentDetailDataTable) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default LoanRepaymentDetail;
